module.exports = __webpack_public_path__ + "img/resized-APP-0026-2.206ef6bf.png";